import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "@auth0/auth0-react";
import history from "./utils/history";
import { getConfig } from "./config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Loading from "./components/Loading";
import "./i18n";

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const queryClient = new QueryClient();

// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider

fetch("/config.json")
  .then((response) => response.json())
  .then((runtimeConfig) => {
    window.appConfig = runtimeConfig;

    const config = getConfig();

    const providerConfig = {
      domain: config.domain,
      clientId: config.clientId,
      onRedirectCallback,
      authorizationParams: {
        redirect_uri: window.location.origin,
        ...(config.audience ? { audience: config.audience } : null),
      },
    };

    const root = createRoot(document.getElementById("root"));
    root.render(
      <Suspense fallback={<Loading />}>
        <QueryClientProvider client={queryClient}>
          <Auth0Provider {...providerConfig}>
            <App />
          </Auth0Provider>
        </QueryClientProvider>
      </Suspense>
    );
  })
  .catch((error) => {
    console.error("Error loading runtime config: ", error);
  });

serviceWorker.unregister();
